import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import Snackbar from '@mui/material/Snackbar'
import {Email, Sms} from '@mui/icons-material'
import SmsContent from 'containers/SmsContent'
import EmailContent from 'containers/EmailContent'
import {resetSmsTemplate} from 'modules/sms/actions'
import {resetEmailTemplate} from 'modules/email/actions'
import {getSmsEmissions, getEmailEmissions} from 'utils/utils'

const IconButton = styled.button`
    background-color: ${props => props.active ? 'rgba(0, 0, 0, .4)' : 'transparent'};
    color: ${props => props.active ? '#ffc300' : 'rgba(255, 255, 255, .7)'};
    font-size: 10px;
    width: 100%;
    height: 60px;
    padding: 10px 5px;
    border: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;

    :hover {
        background-color: rgba(0, 0, 0, .4);
        color: #ffc300;
    }
`

const Buttons = styled.div`
    background-color: rgba(0, 0, 0, .4);
    top: 117px;
    position: absolute;
    width: 100%;
`

const RecordSideButtons = ({entity, name, intl}) => {
	const dispatch = useDispatch()

	const [action, setAction] = useState(null)
	const [anchor, setAnchor] = useState(null)

	const record = useSelector((state) => state.record.record)
	const smsCount = useSelector((state) => state.sms.result)
	const emailCount = useSelector((state) => state.email.result)
	const duplicateEmailTemplate = useSelector((state) => state.email.duplicate)

	const smsEmissions = entity ? getSmsEmissions(entity) : null
	const emailEmissions = entity ? getEmailEmissions(entity) : null

	const emailSuccesses = emailCount && emailCount.valid.length ? emailCount.valid : null
	const emailErrors = emailCount && emailCount.invalid.length ? emailCount.invalid : null

	const smsSuccesses = smsCount && smsCount.valid.length ? smsCount.valid : null
	const smsErrors = smsCount && smsCount.invalid.length ? smsCount.invalid : null

	const open = (!!emailSuccesses && !emailErrors) || (!!smsSuccesses && !smsErrors)

	useEffect(() => {
		if (duplicateEmailTemplate) {
			setAction('email')
		}
	}, [duplicateEmailTemplate])

    const handleOpen = (e) => {
    	setAction(e.currentTarget.value)
		setAnchor(e.currentTarget)
    }

    const handleClose = () => {
        setAction(null)
		setAnchor(null)
    }

    const handleReset = () => {
        if (smsCount) {
            dispatch(resetSmsTemplate())
        } else if (emailCount) {
            dispatch(resetEmailTemplate())
        }
    }

	return (
		<React.Fragment>
			<Buttons>
				{!!emailEmissions && !!emailEmissions.length &&
					<IconButton active={action === 'email'} value='email' onClick={handleOpen}>
						<Email />
						{intl.formatMessage({id: "sidebar.email"})}
					</IconButton>
				}
				{!!smsEmissions && !!smsEmissions.length &&
					<IconButton active={action === 'sms'} value='sms' onClick={handleOpen}>
						<Sms />
						{intl.formatMessage({id: "sidebar.sms"})}
					</IconButton>
				}
			</Buttons>
			{action === 'sms' &&
				<SmsContent
					entity={entity}
					name={name}
					anchorEl={anchor}
					handleClose={handleClose}
					emissions={smsEmissions}
					successes={smsSuccesses}
					errors={smsErrors}
                    documents={[record]}
				/>
			}
			{action === 'email' &&
				<EmailContent
					entity={entity}
					name={name}
					anchorEl={anchor}
					handleClose={handleClose}
					emissions={emailEmissions}
					successes={emailSuccesses}
					errors={emailErrors}
					duplicate={duplicateEmailTemplate}
                    documents={[record]}
				/>
			}
			<Snackbar
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center',
				}}
				onClose={handleReset}
				open={open}
				autoHideDuration={2000}
				message={!!emailSuccesses ?
						intl.formatMessage({id: "sidebar.email_sent_success"}, {count: emailSuccesses.length}) :
					!!smsSuccesses ?
						intl.formatMessage({id: "sidebar.sms_sent_success"}, {count: smsSuccesses.length}) : ''
				}
			/>
		</React.Fragment>
	)
}

export default injectIntl(RecordSideButtons)
